<div>
    <textarea id="ckplot"></textarea>
</div>